// The tolerance band as a component (D-072 signature): rail, band zone,
// setpoint tick and the live-value dot — red the moment the value leaves the
// band. Use it wherever a value has a "should-be"; it encodes the platform's
// core semantic (in band / out of band), never decoration.
import * as stylex from '@stylexjs/stylex';
import '../../tokens/colors.stylex';
import { colors } from '../../tokens/colors.stylex';
import '../../tokens/motion.stylex';
import { motion } from '../../tokens/motion.stylex';
interface BandIndicatorProps {
  /** Current reading; null renders the band with no dot (honest no-reading). */
  value: number | null;
  low: number;
  high: number;
  /** Defaults to the band midpoint. */
  setpoint?: number;
  /** Visible domain override (e.g. the climate tunnel's setpoint ± 2×band);
   *  defaults to the band plus 35% headroom each side. */
  min?: number;
  max?: number;
}
export function BandIndicator({
  value,
  low,
  high,
  setpoint,
  min: minProp,
  max: maxProp
}: BandIndicatorProps) {
  const span = Math.max(high - low, Number.EPSILON);
  // Visible domain: the band plus 35% headroom each side, so out-of-band
  // values stay on the rail instead of vanishing.
  const min = minProp ?? low - span * 0.35;
  const max = maxProp ?? high + span * 0.35;
  const pos = (v: number) => `${(Math.min(Math.max(v, min), max) - min) / (max - min) * 100}%`;
  const sp = setpoint ?? (low + high) / 2;
  const out = value != null && (value < low || value > high);
  return <span className="x1n2onr6 x1v9usgg xh8yej3" role="img" aria-label={`band ${low}–${high}${value != null ? `, value ${value}` : ''}`}>
      <span className="x10l6tqk x17y0mx6 x1atx4j1 x36qwtl xkqg4d9 x1cum3z5" />
      <span className="x10l6tqk xndqk7f xols6we x48i0l6 x18zih8k" style={{
      left: pos(low),
      width: `calc(${pos(high)} - ${pos(low)})`
    }} />
      <span className="x10l6tqk x13vifvy x1ey2m1c xbdjdey x1c1bete xbyyjgo" style={{
      left: pos(sp)
    }} />
      {value != null && <span {...{
      0: {
        className: "x10l6tqk xxk6nc9 x1xc55vz xdk7pt x16rqkct xlvhwkj x1vkh6wh xuuh30 x1660sd"
      },
      1: {
        className: "x10l6tqk xxk6nc9 x1xc55vz xdk7pt x16rqkct x1vkh6wh xuuh30 x1660sd x4qlrbh"
      }
    }[!!out << 0]} style={{
      left: pos(value)
    }} />}
    </span>;
}